import { OktonSearchSelect, OktonSimpleCrudForm } from '@okton/platform-ui';
import { Box, Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import BankAppPage from '../../../layout/BankAppPage';
import {
  usaControlaDRE,
  useDirecionadores,
  useParametros,
  usePlanosDFC,
  useSaveDirecionador,
} from '../../../services/hooks/useCadastros';

const DirecionadorForm = () => {
  const history = useHistory();
  const { idDirecionador } = useParams<{ idDirecionador?: string }>();
  const edicao = !!idDirecionador;

  const { data: direcionadores = [] } = useDirecionadores();
  const registro = direcionadores.find(d => d.id_ori === idDirecionador);
  // O Plano já gravado vai junto: se for um nível de classificação, de um
  // cadastro anterior à regra, ele continua aparecendo em vez de sumir.
  const { data: planosDFC = [] } = usePlanosDFC(registro?.contacustodfc_pcc);
  const { data: parametros } = useParametros();
  const controlaDRE = usaControlaDRE(parametros);
  const saveMutation = useSaveDirecionador();

  const [nome, setNome] = useState('');
  const [planocontas, setPlanoContas] = useState('');
  const [erro, setErro] = useState('');

  // A lista chega depois do primeiro render: sem isso a edição abriria vazia.
  useEffect(() => {
    if (registro) {
      setNome(registro.nome_ori);
      setPlanoContas(registro.contacustodfc_pcc ?? '');
    }
  }, [registro]);

  const salvar = async () => {
    if (!nome.trim()) {
      setErro('Informe o nome do Direcionador.');
      return;
    }
    if (controlaDRE && !planocontas) {
      setErro('Informe o Plano de Contas (DFC).');
      return;
    }
    setErro('');
    try {
      await saveMutation.mutateAsync({
        id: idDirecionador,
        nome: nome.trim(),
        planocontas,
      });
      history.push('/direcionadores');
    } catch (err) {
      setErro(
        err instanceof Error ? err.message : 'Erro ao gravar o Direcionador.',
      );
    }
  };

  return (
    <BankAppPage>
      <>
        <OktonSimpleCrudForm
          horizontalSpacing={0}
          title={edicao ? 'Editar Direcionador' : 'Novo Direcionador'}
          description="Orientador de Operação usado na classificação dos lançamentos"
          onCancel={() => history.push('/direcionadores')}
          nameLabel="Nome"
          name={nome}
          onNameChange={setNome}
          maxName={120}
          error={erro}
          saving={saveMutation.isLoading}
          onSave={salvar}
          footer={
            <Text fontSize="xs" color="gray.500">
              {edicao
                ? 'Tipo, Tipo de Venda e Sugestão de Preço continuam como estão na tela de Orientador do IFLEX. Com Movimentos ou títulos já vinculados o nome fica travado — só o Plano de Contas pode mudar.'
                : 'Nasce com Tipo "Outros", Tipo de Venda "Normal" e Sugestão de Preço "Preço de Venda". Os demais Planos de Contas ficam para a tela de Orientador do IFLEX.'}
            </Text>
          }
        >
          <Box>
            <Text fontSize="sm" fontWeight="medium" mb="1">
              Plano de Contas (DFC) {controlaDRE && '*'}
            </Text>
            <OktonSearchSelect
              name="planocontas"
              placeholder="Sem classificação"
              value={planocontas}
              onChange={valor => setPlanoContas(valor)}
              options={[
                ...planosDFC.map(p => ({
                  value: p.id_pct,
                  label: `${p.item_pct} ${p.nome_pct}`,
                })),
              ]}
            />
          </Box>
        </OktonSimpleCrudForm>
      </>
    </BankAppPage>
  );
};

export default DirecionadorForm;
